<template>
  <div id="faq-page">
    <!-- JUMBOTRON -->
    <div class="faq-jumbotron">
      <div class="faq-jumbotron-content lg:p-32 md:p-24 sm:p-16 p-8 rounded-lg mb-base">
        <h1 class="mb-1 text-white">Tem Alguma Dúvida?</h1>
        <p class="text-white">
          Leia as maiores dúvidas de nossos clientes em nossa base de dados de perguntas e respostas.
        </p>
        <p style="color: red; padding: 6px; background: white; border-radius: 6px">
          Código de Cliente: {{user_id}}
        </p>
        <div class="demo-alignment">
          <a :href="`https://api.whatsapp.com/send?phone=${appWhatsAppMobileNumber}`">
            <vs-chip color="success">
              <vs-icon icon-pack="fa" icon="fa-whatsapp" style="margin-right: 5px"></vs-icon>
              <span>  {{appTelefoneFormatadoWhatsapp}} </span>
            </vs-chip>
          </a>

          <a :href="`tel:${appTelefoneNaoFormatado}`">
            <vs-chip>
              <vs-icon icon-pack="fas" icon="fa-phone-volume" style="margin-right: 5px"></vs-icon>
              <span>{{ appTelefoneFormatado }}</span>
            </vs-chip>
          </a>
          <a :href="`${appLinkSuporte}`" target="_blank">
            <vs-chip color="primary">
              <vs-icon icon-pack="fas" icon="fa-envelope" style="margin-right: 5px"></vs-icon>
              <span> {{ appEmailSuporte}} </span>
            </vs-chip>
          </a>
        </div>

        <vs-input
          placeholder="Buscar"
          v-model="faqSearchQuery"
          icon-pack="feather"
          icon="icon-search"
          size="large"
          class="w-full mt-6"
          icon-no-border
        />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full md:w-2/5 lg:w-1/4 rounded-lg">
        <vx-card>
          <h4>Categorias</h4>
          <ul class="faq-topics mt-4">
            <li
              v-for="category in categories"
              :key="category.id"
              class="p-2 font-medium flex items-center"
              @click="faqFilter = category.id"
            >
              <div class="h-3 w-3 rounded-full mr-2" :class="'bg-' + category.color"></div>
              <span class="cursor-pointer">{{ category.name }}</span>
            </li>
          </ul>
        </vx-card>
      </div>

      <!-- FAQ COL -->
      <div class="vx-col w-full md:w-3/5 lg:w-3/4 mt-12 md:mt-0">
        <vs-collapse accordion type="margin" class="p-0">
          <vs-collapse-item
            v-for="(que, index) in filteredFaq"
            class="faq-bg rounded-lg"
            :class="{ 'mt-0': !index }"
            :key="que.id"
          >
            <div slot="header">
              <h5>{{ que.question }}</h5>
            </div>
            <p>{{ que.ans }}</p>
          </vs-collapse-item>
        </vs-collapse>
        <a href="https://www.wtsoftware.com.br/suporte/faq.html" target="_blank">
            <vs-chip color="primary">
              <vs-icon icon-pack="fas" icon="fa-info" style="margin-right: 5px"></vs-icon>
              <span> Veja todas as Perguntas Frequentes </span>
            </vs-chip>
          </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user_id: null,
      appLinkSuporte: process.env.VUE_APP_LINK_SUPORTE,
      faqSearchQuery: '',
      faqFilter: 1,
      categories: [
        {
          id: 1,
          name: 'Dúvidas Gerais',
          color: 'grey',
        },
        {
          id: 2,
          name: process.env.VUE_APP_NAME,
          color: 'primary',
        },
        {
          id: 3,
          name: 'Compatibilidade',
          color: 'success',
        },
        {
          id: 4,
          name: 'Compra',
          color: 'warning',
        },
        {
          id: 5,
          name: 'Netspy Cloud',
          color: 'danger',
        },
        {
          id: 6,
          name: 'Serviços/Promoções',
          color: 'grey',
        },
      ],
      faqs: [
        {
          id: 1,
          categoryId: 1,
          question: 'Posso Instalar Gratuitamente em quantos celulares?',
          ans:
            'Em sua conta você pode adicionar quantos dispositivos você quiser, ou seja, você pode testar em quantos aparelhos achar melhor.',
        },
        {
          id: 2,
          categoryId: 2,
          question: 'Posso escutar as chamadas?',
          ans:
            'O programa vai monitorar o registro das chamadas, ou seja você terá acesso a informações como quem ligou (nome ou número), quando (data e horário) e o status da ligação (se ela foi perdida, efetuada ou recebida)',
        },
        {
          id: 3,
          categoryId: 3,
          question: 'Funciona em iphone?',
          ans:
            'Por enquanto nosso programa é disponível apenas para aparelhos Android, agora se você quer utilizar um iPhone para monitorar um Android é possível.',
        },
        {
          id: 4,
          categoryId: 4,
          question: 'Quanto custa o monitoramento?',
          ans: 'Temos planos de 1 mês a 1 ano, os valores são de R$ 199,00 para 1 Mês.',
        },
        {
          id: 5,
          categoryId: 5,
          question: 'Por quanto tempo o conteúdo monitorado estará no cloud?',
          ans:
            'O conteúdo fica disponível no painel durante 7 dias, conforme os dias vão passando ele vai deletando os dados mais antigos.',
        },
        {
          id: 6,
          categoryId: 6,
          question: 'Tenho desconto na renovação?',
          ans: 'Sim, para solicitar o link de compra com desconto, entre em contato conosco.',
        },
      ],
      appTelefoneNaoFormatado: process.env.VUE_APP_TELEFONE_NAO_FORMATADO,
      appTelefoneFormatado: process.env.VUE_APP_TELEFONE_FORMATADO,
      appWhatsAppMobileNumber: process.env.VUE_APP_TELEFONE_NAO_FORMATADO_WHATSAPP,
      appTelefoneFormatadoWhatsapp: process.env.VUE_APP_TELEFONE_FORMATADO_WHATSAPP,
      appEmailSuporte: process.env.VUE_APP_EMAIL_SUPORTE
    };
  },
  computed: {
    filteredFaq() {
      return this.faqs.filter((faq) => {
        if (this.faqFilter == 1)
          return (
            faq.question.toLowerCase().includes(this.faqSearchQuery.toLowerCase()) ||
            faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase())
          );
        else if (this.faqFilter == 2)
          return (
            faq.categoryId == 2 &&
            (faq.question.toLowerCase().includes(this.faqSearchQuery.toLowerCase()) ||
              faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase()))
          );
        else if (this.faqFilter == 3)
          return (
            faq.categoryId == 3 &&
            (faq.question.toLowerCase().includes(this.faqSearchQuery.toLowerCase()) ||
              faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase()))
          );
        else if (this.faqFilter == 4)
          return (
            faq.categoryId == 4 &&
            (faq.question.toLowerCase().includes(this.faqSearchQuery.toLowerCase()) ||
              faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase()))
          );
        else if (this.faqFilter == 5)
          return (
            faq.categoryId == 5 &&
            (faq.question.toLowerCase().includes(this.faqSearchQuery.toLowerCase()) ||
              faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase()))
          );
        else if (this.faqFilter == 6)
          return (
            faq.categoryId == 6 &&
            (faq.question.toLowerCase().includes(this.faqSearchQuery.toLowerCase()) ||
              faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase()))
          );
      });
    },
  },
  mounted() {
    this.$api
    .post('/api/v1/auth/me')
    .then((response) => {
      this.user_id = response.data.user_id;
    })
    .catch((error) => {
      this.$vs.notify({
        time: 6000,
        title: 'Aviso',
        text: Object.values(error.response.data.errors).join('<br>'),
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger',
      });
    });
  },
};
</script>

<style lang="scss">
#faq-page {
  .faq-jumbotron-content {
    background-image: url('../../assets/images/pages/faq.jpg');
    background-size: cover;
  }

  .faq-bg {
    background-color: #fff;
  }
}
</style>
